import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth} from "firebase/auth";
import {getFirestore} from "firebase/firestore"
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB2ieoOIxLn2urHN4x0oE2GX5dE1il0FCY",
  authDomain: "testapp-e916e.firebaseapp.com",
  projectId: "testapp-e916e",
  storageBucket: "testapp-e916e.appspot.com",
  messagingSenderId: "604369728841",
  appId: "1:604369728841:web:87b1ef73b4ce6b2c319698",
  measurementId: "G-0TFYYP48S0"
};

const app = initializeApp(firebaseConfig);
export const auth= getAuth(app);
export const db=getFirestore(app)
export const storage=getStorage(app)
export const provider=new GoogleAuthProvider();
